import { EmployeeTableItem } from '../interfaces'

export const toTableRowItems = (items: EmployeeTableItem[]) =>
  items.map(item => ({
    id: item.id,
    firstName: item.firstName ?? '',
    lastName: item.lastName ?? '',
    emailAddress: item.emailAddress ?? '',
    adUserName: item.adUserName ?? '',
    globalId: item.globalId ?? '',
    userId: item.userId ?? ''
  }))
